import { render, staticRenderFns } from "./forbidden-dialog.vue?vue&type=template&id=7858bba4&"
import script from "./forbidden-dialog.vue?vue&type=script&lang=ts&"
export * from "./forbidden-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./forbidden-dialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports